import { os } from '../../../utils/device';

export function appURL(token: string): string {
  if (os?.name === 'iOS') {
    return 'itms-apps://apps.apple.com/app/idnow-online-ident/id918081242';
  }
  if (os?.name === 'Android') {
    return 'https://play.google.com/store/apps/details?id=de.idnow&hl=en&pli=1';
  }
  // Idnow landing as a fallback
  return `${process.env.IDNOW_IFRAME_DOMAIN}/${token}`;
}
